export default __webpack_public_path__ + "static/media/image.k-weera-it-and-engineering-services.bb5ac8d6.png";